

export default {
    action: "mdi-account-eye",
    title: "RegulatoryViolation",
    permission: "violation",
    items: [

        {
            prefix: "D",
            title: "RegulatoryViolationDamage",
            link: "/regulatory-violation-damage",
            permission: "violation-damage-index",
        },
        {
            prefix: "L",
            title: "RegulatoryViolationLevel",
            link: "/regulatory-violation-level",
            permission: "violation-level-index",
        },

        {
            prefix: "F",
            title: "RegulatoryViolationForms",
            link: "/regulatory-violation-forms",
            permission: "violation-form-index",
        },

        {
            prefix: "O",
            title: "RegulatoryViolationOrder",
            link: "/regulatory-violation-order",
            permission: "violationorder-index",
        },
        // {
        //     prefix: "O",
        //     title: "AssignViolationForm",
        //     link: "/regulatory-violation-order/new",
        //     permission: "violationorder-create",
        // },

        {
            prefix: "O",
            title: "RegulatoryViolationUnAssignCampOrder",
            link: "/regulatory-violation-unassigned-order",
            permission: "violationorder-index",
        },
    ],
}

